export const AuthFormTranslationsUk = {
  placeholderLogin: 'Електронна пошта / Номер телефону',
  description:
    'Авторизуйтеся за допомогою логіну (введіть номер телефону або електронну пошту)',
  login: 'Логін',
  password: 'Пароль',
  passwordPlaceholder: '****',
  forgotPassword: 'Я забув (-ла) свій пароль',
  submitButton: 'Увійти',

  // errors
  'Required field': 'Обов`язкове поле',
  validLogin:
    'Введіть дійсний логін (електронну пошту або дійсний номер телефону)',

  // errors back-end
  'login or password is wrong': 'Логін або пароль неправильний',
};
